import type { IBrandContainer } from './BrandContainer'

import { styled } from '@linaria/react'
import { IconSC } from 'atoms/Icon'
import { PosterSC } from 'atoms/ImagePoster'
import { FIXED_INDENTS, INDENTS, MEDIA } from 'vars/index'

export const IconBrandContainerSC = styled.div`
  padding: var(${FIXED_INDENTS.INDENT_50});
`

export const BrandContainerSC = styled.div<IBrandContainer>`
  display: flex;
  overflow: hidden;
  cursor: pointer;
  text-decoration: none;
  align-items: center;
  flex: 0 0 auto;
  padding: ${({ paddings }) => (paddings?.length ? `var(${paddings}) ` : 0)};

  & ${IconSC} {
    margin: 0 var(${INDENTS.INDENT_35}) 0 0;

    &:only-child {
      margin: 0;
    }
  }

  & ${PosterSC} {
    object-fit: contain;
    object-position: ${({ alignItem }) => `${alignItem}`};
    max-width: ${({ logoWidth }) => logoWidth || 'auto'};
    max-height: ${({ logoHeight }) => logoHeight || 'auto'};
    min-height: ${({ scaleLogo, logoMinHeight }) =>
      scaleLogo && logoMinHeight ? logoMinHeight : 'unset'};
    ${MEDIA.MAX_599} {
      min-height: unset;
    }
  }
`
